export const formatNumber = (val: number) => new Intl.NumberFormat().format(val)
